<div class="coverage-proposal-page">
    <div class="container">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo" (click)="gotoHome()" style="cursor: pointer;" title="Home"></div>
                <h3 class="my-5">{{headerText}}</h3>
                <self-ins-policies-and-request-page></self-ins-policies-and-request-page>
            </div>
            <contacts></contacts>
        </div>
        <div class="main-content">
            <div class="loading-message" *ngIf="isLoading">
                <p>{{ _translateService.Keys.COMMON_LOADING | translate }}</p>
            </div>
            <div class="pdf-cont" *ngIf="pdfContent && !isLoading">
                <pdf-viewer [src]="pdfContent"
                    [render-text]="true"
                    [original-size]="false"
                    class="d-flex h-100 w-100"
                ></pdf-viewer>
            </div>
            <div class="error-message" *ngIf="hasError && !isLoading">
                <p>{{ _translateService.Keys.TOAST_ERROR | translate }}</p>
            </div>
            <div class="actions pt-3" *ngIf="!isLoading">
                <button [routerLink]="['/coverage']"
                        [queryParams]="{ qnum: qnum, qsuffix: qsuffix }"
                        class="primary-button">
                    {{ _translateService.Keys.COMMON_BACK | translate }}
                </button>
                <div *ngIf="!user || user.status !== 'active'">
                    <button (click)="enroll()" class="primary-button ms-3">
                        {{ _translateService.Keys.COMMON_ENROLL_NOW | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
